export const getCurrencySymbol = (currency?: string) => {
  switch (currency?.toLowerCase()) {
    case "pound":
      return "£";
    case "usd":
    case "dollar":
      return "$";
    case "euro":
      return "€";
    default:
      return "$";
  }
};
